export const modalBaseMixin = {
  methods: {
    show() {
      this.$refs["modal"].show();
    }
  }
};
